import Sidebar from '../components/Sidebar';
import { useProjectNavLinks } from '../hooks/useNavLinks';

const LayoutWithSidebar = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return (
    <Sidebar links={useProjectNavLinks()} username={user?.username} />
  );
}

export default LayoutWithSidebar;